import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { createClient } from "./apolloClient";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { CrossStorageHub } from "cross-storage";
import { DASHBOARD_URL } from "./config";

CrossStorageHub.init([
  { origin: new RegExp(`${DASHBOARD_URL}`), allow: ["get"] },
]);

const client = createClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
);

serviceWorker.unregister();
